import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_nd6psatxbw: FaireBrandEntity = {
  token: "b_nd6psatxbw",
  type: "brand",
  name: "Fleurworld",
  avatarUrl:
    "https://cdn.faire.com/fastly/548126c8e9d739e88da2340c331a446155322c896a6e4e00e234681d825b5913.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/89ace4bf9890a023f3d81b72949ceef43afb4e763c381f9698eacad2ac131f14.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/548126c8e9d739e88da2340c331a446155322c896a6e4e00e234681d825b5913.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/89ace4bf9890a023f3d81b72949ceef43afb4e763c381f9698eacad2ac131f14.jpeg",
  location: "LONG BEACH, CA, USA",
  minimumOrderDollars: 100,
  rating: 3.8,
  reviewCount: 12,
  isInsider: true,
  description:
    "Born From Observation, Not Fantasy\nFleurworld was created after observing real women in real cities — women who walk alone at night, work long hours, move with intention, and do not need fashion to soften or explain them.\n\nWe saw an absence in contemporary womenswear: clothing that respects strength, embraces restraint, and allows complexity without decoration.\n\nFleurworld does not chase trends. We design garments as tools — wearable structures for independent women.\n\nThe Dark Friend Spirit\nDark Friend Energy is not aggression. It is the calm presence that does not seek validation.\n\nFleurworld represents women who are emotionally independent, mentally grounded, and visually restrained.\n\nBlack and white are not aesthetic choices — they are a language of control, contrast, and honesty.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:15.733Z",
    importedBy: "entity-db-cli",
  },
};
